import * as React from 'react';
import { useGetForestOwnerQuery } from "../../../apis/ForestOwner.api";
import { PrimaryForestOwner, ForestOwner } from "../../../types/models/ForestOwner";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: ForestOwner;
};

export const ForestOwnerNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const ForestOwnerName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetForestOwnerQuery(PrimaryForestOwner.fromId(id))
    return (<ForestOwnerNameDisplay data={data}/>)
}

export default ForestOwnerName;
